module.exports = __webpack_public_path__ + "static/media/history-buddha.d0cc6b5f.mp4";